<template>
    <div class="header-hero">
        <div class="hero-image" :style="{backgroundImage: 'linear-gradient(rgba(0, 65, 107, 0.68), rgba(0, 65, 107, 0.68)), url('+ heroImage +')'}">
            <div class="hero-text header-text">
                <h1 class="display-3">{{ heroTitle }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Hero',
        props: [
            'heroTitle',
            'heroImage'
        ]
    }
</script>

<style lang="scss">
    
    
</style>




// WEBPACK FOOTER //
// src/components/frontend/Hero.vue